import api from '../../../services/api';

export const rentabilidadGlobalAPI = {
  getResumen: (params) => api.get('/rentabilidad-global/resumen', { params }),
  getBandeja: (params) => api.get('/rentabilidad-global/bandeja', { params }),
  getAnalisis: (params) => api.get('/rentabilidad-global/analisis', { params }),
  getProduccion: (params) => api.get('/rentabilidad-global/produccion', { params }),
  getRentabilidad: (params) => api.get('/rentabilidad-global/rentabilidad', { params }),
  getCobranza: (params) => api.get('/rentabilidad-global/cobranza', { params }),
  getCostosFijosResumen: (params) => api.get('/rentabilidad-global/costos-fijos-resumen', { params }),
  getPlazos: (params) => api.get('/rentabilidad-global/plazos', { params }),
  getClientes: (params) => api.get('/rentabilidad-global/clientes', { params }),
  getServicios: (params) => api.get('/rentabilidad-global/servicios', { params }),
  getResponsables: (params) => api.get('/rentabilidad-global/responsables', { params }),
  getRetrabajos: (params) => api.get('/rentabilidad-global/retrabajos', { params }),
  getDatosBruto: (params) => api.get('/rentabilidad-global/datos-bruto', { params }),
  getConfig: () => api.get('/rentabilidad-global/config'),
  patchConfig: (data) => api.patch('/rentabilidad-global/config', data),
  getPerfilesLaborales: () => api.get('/rentabilidad-global/perfiles-laborales'),
  patchPerfilLaboral: (usuarioId, data) => api.patch(`/rentabilidad-global/perfiles-laborales/${usuarioId}`, data),
  getCostosDirectos: (expedienteId) => api.get(`/rentabilidad-global/costos-directos/${expedienteId}`),
  postCostoDirecto: (expedienteId, data) => api.post(`/rentabilidad-global/costos-directos/${expedienteId}`, data),
  deleteCostoDirecto: (id) => api.delete(`/rentabilidad-global/costos-directos/${id}`),
  exportar: (tipo, params) => api.post(`/rentabilidad-global/exportar/${tipo}`, params, { responseType: 'blob' }),
  patchExpedienteAdmin: (id, data) => api.patch(`/rentabilidad-global/expediente/${id}/admin`, data),
  buscarExpediente: (q) => api.get('/rentabilidad-global/buscar-expediente', { params: { q } }),
};
